import { Component, Input, ViewChildren, QueryList, AfterViewInit } from '@angular/core';
import { CCategoryAnswerDto, CropDto, CertificationAnswerServiceServiceProxy, CAnswerDto, CBehaviorTypeEnum, CAnswerLevelEnum, FarmerNutrientRecommendationQuantityDto, FarmerCropQuantityDto, CCertificationStatusEnum } from '@shared/service-proxies/service-proxies';
import { AppThemeColors } from 'src/app/app-theme-colors-enum';
import { CertificationMasterSectionEnum } from '../model/certification-master-section-enum';
import { AccordionComponent } from '../../../components/accordion/accordion/accordion.component';
import { AccordionPanelComponent } from 'src/app/components/accordion/accordion-panel/accordion-panel.component';
import { CertificationPage } from '../certification.page';

@Component({
  selector: 'app-certification-category',
  templateUrl: './certfication-category.component.html',
  styleUrls: ['./certfication-category.component.scss'],
})
export class CertificationCategoryComponent implements AfterViewInit {
  id: number;
  answer: CAnswerDto;

  @Input() certificationId: number;
  @Input() farmerCrops: FarmerCropQuantityDto[]=[];

  @Input() category: CCategoryAnswerDto;
  @Input() answerLevels: number[];
  @Input() answerLevel: number;
  @Input() farmerCrop: FarmerCropQuantityDto;
  @Input() farmerNutrientRecommendations: FarmerNutrientRecommendationQuantityDto[]=[];
  @ViewChildren('categoryLevelPanels') categoryLevelPanels: QueryList<CertificationCategoryComponent>;
  @Input() accordion: AccordionComponent;
  @Input() panel: AccordionPanelComponent;
  @Input() certificationPage: CertificationPage;
  answerValue: any;
  constructor(
    private answerService: CertificationAnswerServiceServiceProxy
  ) { }

  ngAfterViewInit(){ // ngOnInit() {
    if (this.category) {
      let hasAnswer = false;
      if (this.category.answers) {
        if (
          this.answerLevel == CAnswerLevelEnum._0 &&
          this.category.answers.owned &&
          this.category.answers.owned[0]
        ) {
          hasAnswer = true;
          this.answer = this.category.answers.owned[0];
        } else if (
          this.answerLevel == CAnswerLevelEnum._1 &&
          this.category.answers.rented &&
          this.category.answers.rented[0]
        ) {
          hasAnswer = true;
          this.answer = this.category.answers.rented[0];
        }
      }
      if (hasAnswer) {
        this.id = this.answer.id;
        this.answerValue = this.answer.answer;
      } else {
        if (
          this.category.id == 30 &&
          this.farmerNutrientRecommendations &&
          this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService)
        ) { // 3-4 years
          if (this.answerLevel == CAnswerLevelEnum._0) {
            this.answerValue = this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService).ownedQuantity;
          } else if (this.answerLevel == CAnswerLevelEnum._1) {
            this.answerValue = this.farmerNutrientRecommendations.find(x => x.nutrientRecommendationIsFullService).rentedQuantity;
          }
        }
      }
    }
  }
  shouldShowOwned(): boolean {
    return this.answerLevels.includes(0);
  }
  shouldShowRented(): boolean {
    return this.answerLevels.includes(1);
  }
  getCategoryColor(category: CCategoryAnswerDto) {
    switch(category.id) {
      case CertificationMasterSectionEnum.NutrientApplicationRate:
        return AppThemeColors.OliveGreen;
      case CertificationMasterSectionEnum.NutrientApplicationPlacement:
        return AppThemeColors.DarkCyan;
      case CertificationMasterSectionEnum.InFieldManagement:
        return AppThemeColors.BabyBlue;
      case CertificationMasterSectionEnum.StructuralPractices:
        return AppThemeColors.Purple;
    }
  }
  saveAnswer(event) {
    let doSave = true;
    const request = this.answer ? this.answer : new CAnswerDto();
    request.answer = this.answerValue;
    if (!this.answerValue) {
      doSave = false;
    }
    request.answerLevelId = this.answerLevel;
    request.categoryId = this.category.id;
    request.certificationId = this.certificationId;
    if (
      this.answerValue && 
      this.category.behaviorTypeId == CBehaviorTypeEnum._3 &&
      this.farmerCrop
    ) {
      request.objectId = this.farmerCrop.cropId;
      request.answer = event.detail.checked;
      doSave = true;
    }
    if (doSave) {
      this.answerService.save(request).subscribe(answer => {
        this.id = answer.id;
        this.answer = answer;
        // ok we saved an answer.. if new cert we need to say it's in progress now
        if (this.certificationPage.certification.statusId == CCertificationStatusEnum._0) {
          this.certificationPage.setInProgress();
        }
      });
    }
  }

  getCropToggleAnswerValue() {
    if (
      this.answer &&
      this.farmerCrop &&
      this.answer.objectId == this.farmerCrop.cropId
    ) {
      return this.answer.answer;
    } else {
      return null;
    }
  }

  openAccordion(event) {
    console.log(event);
    // if (event.srcElement.localName == 'ion-toggle') {

    // } else {
      // this.certificationPage.collapseExcept(this.panel);
    // }
  }
}
